import React from "react";
import { Flame } from "lucide-react";
import { useShareStreak } from "@/hooks/useShareStreak";

/**
 * Iter-586 — rewards-hub share-streak card. Counts come from the
 * shared backend (GET /my/share-streak), never local storage.
 */
export default function ShareStreakCard() {
  const q = useShareStreak();
  const d = q.data;
  if (!d || typeof d.posts_total !== "number") return null;

  const total = d.posts_total;
  const next = d.next_milestone;
  const toNext = d.posts_to_next;
  const pct = next > 0 ? Math.min(100, Math.round((total / next) * 100)) : 100;

  return (
    <div className="rounded-2xl bg-white shadow-card p-5" data-testid="rewards-share-streak">
      <div className="flex items-center gap-2">
        <span className="w-8 h-8 rounded-full bg-orange-100 grid place-items-center">
          <Flame className="w-4 h-4 text-orange-500" />
        </span>
        <div className="text-sm font-bold text-slate-900">Share streak</div>
      </div>
      {total === 0 ? (
        <p className="mt-2.5 text-sm text-slate-600" data-testid="rewards-streak-empty">
          Share your first store visit to start your streak — every post earns points.
        </p>
      ) : (
        <>
          <div className="mt-2.5 flex items-baseline gap-1.5">
            <span className="text-2xl font-black text-slate-900" data-testid="rewards-streak-total">
              {total}
            </span>
            <span className="text-sm text-slate-500">post{total === 1 ? "" : "s"} shared</span>
          </div>
          <div className="mt-2 h-2 rounded-full bg-slate-100 overflow-hidden">
            <div
              className="h-full rounded-full bg-orange-400 transition-[width]"
              style={{ width: `${pct}%` }}
            />
          </div>
          <p className="mt-2 text-xs font-semibold text-slate-600" data-testid="rewards-streak-nudge">
            {d.milestone_hit
              ? `🎉 Milestone reached — ${total} posts!`
              : `Only ${toNext} more to reach ${next}!`}
          </p>
        </>
      )}
    </div>
  );
}
